/*
  mock地址： http://mock.jdfmgt.com/interface?projectId=62f5c111855696ad35fc3d4d
*/
export default [
  {
    /**
     * 我的融资列表
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c71aff54b57a7352007e1
     */
    name: 'pageQueryFinanceList',
    method: 'post',
    url: '/finhub/front/finance/query/pageQueryFinanceList',
  },
  {
    /**
     * 	我的融资详情
     *  https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c71f1af50ba51ae0c9d2b
     */
    name: 'financeDetailMe',
    method: 'post',
    url: '/finhub/front/finance/query/financeDetail',
  },
  {
    /**
     * 	还款计划
     *  https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c72f4f54b57a7352007e3
     */
    name: 'financeRepaymentSchedule',
    method: 'post',
    url: '/finhub/front/finance/query/financeRepaymentSchedule',
  },
  {
    /**
     * 	还款明细
     *  https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c732af54b57a7352007e5
     */
    name: 'financeRepaymentRecord',
    method: 'post',
    url: '/finhub/front/repay/getRepayDetail',
  },
  {
    /**
     * 	融资产品
     *
     */
    name: 'selectOpenProductList',
    method: 'post',
    url: '/finhub/front/finance/query/selectOpenProductList',
  },
  {
    /**
     * 	模拟资方融资
     *
     */
    name: 'financeNotice',
    method: 'post',
    url: '/finhub/front/mock/financeNotice',
  },
  {
    /**
     * 	模拟资方授信
     *
     */
    name: 'creditNotice',
    method: 'post',
    url: '/finhub/front/mock/creditNotice',
  },
  {
    /**
     * 	模拟资方还款
     *
     */
    name: 'repayNotice',
    method: 'post',
    url: '/finhub/front/mock/repayNotice',
  },
  {
    /**
     * 	收款方账号
     *
     */
    name: 'queryAllPayeeAccount',
    method: 'post',
    url: '/finhub/front/core/queryAllPayeeAccount',
  },
  {
    /**
     * 	立即融资按钮
     *
     */
    name: 'productCgFinanceApply',
    method: 'post',
    url: '/finhub/front/finance/command/productCgFinanceApply',
  },
  {
    /**
     * 	绑定订单
     *
     */
    name: 'financeCgBindSubjectData',
    method: 'post',
    url: '/finhub/front/finance/command/financeCgBindSubjectData',
  },
]
